module.exports = __webpack_public_path__ + "static/media/action_image.de946ea6.png";